import React from "react";
import { Col, Container, Row } from "reactstrap";

import Section from "./Section";

import AddStock from "./AddStock";

const JobDetails = () => {
  document.title = 'AddStock | StarMarket';
  return (
    <React.Fragment>
      
      
            <AddStock />
         
        
     
    </React.Fragment>
  );
};

export default JobDetails;
